import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputLabel: {
      fontSize: '20px'
    },
    root: {
      display: 'flex'
    },
    wrapper: {
      margin: theme.spacing(1),
      position: 'relative',
      top: 5
    },

    fabProgress: {
      position: 'absolute',
      top: 6,
      left: 6,
      zIndex: 1
    },
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    },
    success: {
      backgroundColor: '#d4edda',
      border: '1px solid #c3e6cb',
      color: '#155724',
      borderRadius: '20px',
      textIndent: '5px'
    },
    error: {
      backgroundColor: '#f8d7da',
      border: '1px solid #f5c6cb',
      color: '#721c24',
      borderRadius: '20px',
      textIndent: '5px'
    }
  })
)
